module.exports = __webpack_public_path__ + "img/TypeScript.4a522623.png";